import { Break } from "../Break";
import styles from "./index.module.scss";

/**
 * A break to be used in the context of a card component
 */
export const CardBreak = () => <Break customClass={styles["card-break"]} />;
